import Flex from '@decisiv/ui-components/lib/components/Flex';
import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';
import spacing from '@decisiv/design-tokens/lib/spacing';
import color from '@decisiv/design-tokens/lib/color';

export const FormContainer = styled(Flex).attrs({ flex: 1 })`
  flex-direction: column;
  gap: ${rem(spacing.base * 1)};

  & > div {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const PrimaryContactContainer = styled(Flex)`
  flex-direction: column;
  gap: ${rem(10)};
`;

export const ContactOptionSubtitle = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base / 2)};
  color: ${toColorString(color.base.alaskanHusky)};
`;
